/** Defines if number is a multiple of 10 */
export const isMultipleOfTen = (value: number): boolean => {
  return value % 10 === 0
}

/** Defines if number is a multiple of 20 */
export const isMultipleOfTwenty = (value: number): boolean => {
  return value % 20 === 0
}
